import { BaseResponse } from "@bitwarden/common/models/response/base.response";

export class OrganizationUserPendingAutoConfirmResponse extends BaseResponse {
  /** The OrganizationUser ID â used for the confirm call. */
  id: string;
  /** The User ID â used for public key lookup. */
  userId: string;

  constructor(response: any) {
    super(response);
    this.id = this.getResponseProperty("Id");
    this.userId = this.getResponseProperty("UserId");
  }
}
